(($, Drupal, drupalSettings) => {
    /**
     * Create slider.
     */
    Drupal.behaviors.slider = {
        attach: function(context, settings) {
            fn();
            
            function debounce(func, wait, immediate) {
                var timeout;
                return function () {
                    var context = this, args = arguments;
                    var later = function () {
                        timeout = null;
                        if (!immediate) func.apply(context, args);
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) func.apply(context, args);
                };
            }
            function fn() {
                $(function () {
                    var showcase = $("#showcase");
                    showcase.Cloud9Carousel( {
                        itemClass: 'slider-item',
                        frontItemClass: 'slider-active',
                        yOrigin: 1,
                        yRadius: 0,
                        farScale: 0.3,
                        mirror: {
                            gap: 12,
                            height: 0.2
                        },
                        buttonLeft: $("#nav > .left"),
                        buttonRight: $("#nav > .right"),
                        bringToFront: true,
                    } );
                });
            }
            window.addEventListener('resize', debounce(function (event) {
                fn();
            }, 200));

        }
    };
})(jQuery, Drupal, drupalSettings);
